import React from "react";
import { Text } from "@components/formx";

export function TravelInfo() {
  return (
    <div>
      <Text TextFieldProps={{ multiline: true }} name={"personal.travelPreferences"} />
    </div>
  );
}
